import { useState } from 'react';

import { usePageProps } from '@zillow/cms-utils';
import { Box, Button, Modal } from '@zillow/constellation-10';
import { IconPlayCircleFilled } from '@zillow/constellation-icons';

import { emitVideoCtaCloseEvent, emitVideoCtaOpenEvent } from '../../analytics/videoCtaEvents';

import type { ButtonSize } from './buttonSize';

type Props = {
  label: string;
  size: ButtonSize;
  videoUrl: string;
};

const VideoCtaButton = ({ label, size, videoUrl }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const pageProps = usePageProps();

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open);
    if (open) {
      emitVideoCtaOpenEvent(pageProps);
    } else {
      emitVideoCtaCloseEvent(pageProps);
    }
  };

  return (
    <>
      <Button
        emphasis="outlined"
        icon={<IconPlayCircleFilled />}
        iconPosition="end"
        onClick={() => handleOpenChange(true)}
        size={size}
        tone="brand"
      >
        {label}
      </Button>
      <Modal.Root open={isOpen} onOpenChange={handleOpenChange} size={{ base: 'fullScreen', md: 'xl' }}>
        <Modal.Portal>
          <Modal.Backdrop>
            <Modal.Content aria-label={label}>
              <Modal.CloseButton />
              <Modal.Body>
                <Box css={{ aspectRatio: '16 / 9', width: '100%' }}>
                  <iframe
                    allow="autoplay; encrypted-media; fullscreen"
                    allowFullScreen
                    referrerPolicy="strict-origin-when-cross-origin"
                    sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"
                    src={videoUrl}
                    style={{ border: 0, height: '100%', width: '100%' }}
                    title={label}
                  />
                </Box>
              </Modal.Body>
            </Modal.Content>
          </Modal.Backdrop>
        </Modal.Portal>
      </Modal.Root>
    </>
  );
};

export default VideoCtaButton;
